import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IMessage } from '../../models/chatbot.interfaces';
import { Store } from '@ngxs/store';
import { ChatbotActions } from '../../state/chatbot.actions';
import { ChatbotState } from '../../state/chatbot.state';
import { Router } from '@angular/router';

@Component({
  selector: 'hf-chatbot-footer',
  templateUrl: './chatbot-footer.component.html',
  styleUrls: ['./chatbot-footer.component.scss']
})
export class ChatbotFooterComponent implements OnInit {
  public chatbotUserResponseFormGroup: UntypedFormGroup;
  // Disable send button when chatbot is streaming or thinking.
  public chatbotStreaming$ =
    this.store.select(ChatbotState.isStreaming) || this.store.select(ChatbotState.isChatbotThinking);
  private conversationId: string;

  constructor(
    private fb: UntypedFormBuilder,
    private readonly store: Store,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.chatbotUserResponseFormGroup = this.fb.group({
      question: ['', Validators.required]
    });

    this.store.select(ChatbotState.chatbotState).subscribe((s) => {
      this.conversationId = s?.conversationHistory.conversationId;
    });
  }

  // Method that sends the user question
  // dispatch an action that triggers a dispatch Action that sends the question to the backend via WebSocket
  public sendQuestion() {
    if (
      this.store.selectSnapshot(ChatbotState.isStreaming) ||
      this.store.selectSnapshot(ChatbotState.isChatbotThinking)
    ) {
      return; // prevent double send & send with keyboard
    }
    const entityContextRoute = this.getEntityContextRoute();

    const dateTime = new Date();
    const rawValue: string = this.chatbotUserResponseFormGroup.get('question').value || '';
    const messageContent = rawValue.trim();

    // Prevent sending empty or whitespace-only messages
    if (!messageContent || messageContent === '') {
      return;
    }

    if (this.store.selectSnapshot(ChatbotState.isNewChatState)) {
      this.store.dispatch(new ChatbotActions.NewChatUI(false));
    }
    // Sends message via WebSocket
    this.store.dispatch(new ChatbotActions.SendWSMessage(this.conversationId, messageContent, entityContextRoute));
    // Appends the message to the chat history on the UI
    this.store.dispatch(
      new ChatbotActions.AppendUiMessage({
        id: null,
        type: 'USER',
        content: messageContent,
        createdDate: dateTime
      } as IMessage)
    );

    // clears the question input field
    this.chatbotUserResponseFormGroup.get('question').setValue('');
  }

  getEntityContextRoute(): string {
    const url = this.router.url;
    return url.startsWith('/app') ? url.replace(/^\/app/, '') : url; // removes the 'app'
  }
}
